import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ListHeadingComponent from "components/headingComponent/listHeading";
import AddButton from "components/buttons/addbutton";
import ListButtons from "components/buttons/listButtons";
import CommonHeadings from "helper/constant/headings";
import RoutingPaths from "helper/routingPath";
import Constant from "helper/constant/constant";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import Dateformat from "helper/constant/timeFormat";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { ButtonGroup } from "react-bootstrap";
import * as XLSX from "xlsx";
import {
    collection,
    deleteDoc,
    doc,
    endBefore,
    getDocs,
    limit,
    limitToLast,
    orderBy,
    query,
    startAfter,
    Timestamp,
    where,
} from "firebase/firestore";
import Swal from "sweetalert2";
import Moment from "react-moment";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";



function NotesData() {
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [notesData, setNotesData] = useState([]);
    const [page, setPage] = useState(0);
    const navigate = useNavigate();
    const [isNext, setIsNext] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [filteredDates, setFilteredDates] = useState(null);

    // MARK: use Effect
    useEffect(() => {
        fetchNotesApi();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    //use layout effect function
    useLayoutEffect(() => {
        document.title = CommonHeadings.notesLayoutHeading;
    }, []);

    // MARK:  function using in input
    const tapOnDateInput = (e) => {
        setFilteredDates(e.value);
    };

    //  reset button function
    const tapOnResetButton = () => {
        setFilteredDates(null);
        fetchNotesApi();
    };


    // MARK: API
    // fetch students API
    async function fetchNotesApi() {
        const q = query(
            collection(dbFirestore, TableName.notes),
            orderBy("created_at", "desc"),
            limit(Constant.perPage)
        );

        const querySnapshot = await getDocs(q);
        console.log(querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id })))
        setNotesData(
            querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
        );
        setLoading(false);
        setPage(0);
        setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    }

    // delete API
    const deleteNotesApi = async (data) => {
        await deleteDoc(doc(dbFirestore, TableName.notes, data.id));
        setNotesData((prevState) =>
            prevState.filter((el) => el.id !== data.id || "" )
        );
        toast.success(ToastMessages.noteDeleted);
    };

    // serach api

    const searchNotesApi = async (e) => {
        const searchText = e.target.value.toLowerCase();
        setGlobalFilterValue(searchText);

        if (searchText) {
            // fetch a limited amount (say 50 or 100)
            const q = query(
                collection(dbFirestore, TableName.notes),
                orderBy("created_at", "desc"),
                limit(100)
            );

            const querySnapshot = await getDocs(q);

            const filteredData = querySnapshot.docs
                .map((doc) => ({ ...doc.data(), id: doc.id }))
                .filter(note => note.note_data.toLowerCase().includes(searchText));

            setNotesData(filteredData);
        } else {
            fetchNotesApi();
        }
    };

    // MARK: filter dates
    function getFilteredDatesTimeStamp() {
        if (filteredDates) {
            const startDate = moment(filteredDates[0]).format(Dateformat.YYYYMMDD);
            const endDate = moment(filteredDates[1]).format(Dateformat.YYYYMMDD);

            const startTimestamp = Timestamp.fromDate(new Date(startDate)).toMillis();
            const endTimestamp = Timestamp.fromDate(new Date(endDate)).toMillis();
            return { startTime: startTimestamp, endTime: endTimestamp };
        }
        return null;
    }

    // MARK: filter function using in input
    const tapOnFilterButton = async () => {
        const querySnapshot = await createQueryForTable();

        const array = querySnapshot.docs.map((docs) => ({ ...docs.data() }));
        setNotesData(array);
        setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    async function createQueryForTable() {
        const filterText = filteredDates;

        if (!filterText) {
            toast.error(ToastMessages.filterDate);
            <ToastContainer />
        }

        if (filterText) {
            let q = query(
                collection(dbFirestore, TableName.notes),
                where("created_at", ">=", getFilteredDatesTimeStamp().startTime),
                where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
                orderBy("created_at", "desc"), limit(Constant.perPage)
            );
            const querySnapshot = await getDocs(q);

            return querySnapshot;
        } else {
            const q = query(
                collection(dbFirestore, TableName.notes),
                orderBy("created_at", "desc"),
                limit(Constant.perPage)
            );
            const querySnapshot = await getDocs(q);
            return querySnapshot;
        }
    }

    async function createQueryForExport() {
        const filterText = filteredDates;

        if (!filterText) {
            toast.error(ToastMessages.filterDate);
            <ToastContainer />
        }

        if (filterText) {
            let q = query(
                collection(dbFirestore, TableName.notes),
                where("created_at", ">=", getFilteredDatesTimeStamp().startTime),
                where("created_at", "<=", getFilteredDatesTimeStamp().endTime),
                orderBy("created_at", "desc")
            );

            const querySnapshot = await getDocs(q);
            return querySnapshot;
        } else {
            const q = query(
                collection(dbFirestore, TableName.notes),
                orderBy("created_at", "desc"),
            );

            const querySnapshot = await getDocs(q);
            return querySnapshot;
        }
    }

    //MARK: Search UI
    const searchBar = () => {
        return (
            <>
                <div className="search__main_div">
                    <div style={{ flexGrow: "1" }}>
                        <IconField iconPosition="left">
                            <InputIcon className="pi pi-search" />
                            <InputText
                                type="search"
                                value={globalFilterValue}
                                onChange={searchNotesApi}
                                placeholder="Search by name"
                            />
                        </IconField>
                    </div>
                    <div className="filter__button-section">
                        <Calendar
                            value={filteredDates}
                            onChange={tapOnDateInput}
                            selectionMode="range"
                            readOnlyInput
                            showIcon
                            placeholder="Select start and end date"
                        />

                        <Button
                            type="button"
                            label="Filter"
                            className="list__filter_button ms-2 me-2"
                            onClick={tapOnFilterButton}
                        />
                        <Button
                            type="button"
                            label="Reset"
                            className="list__reset_button"
                            onClick={tapOnResetButton}
                        />
                    </div>
                </div>
            </>
        );
    };

    const header = searchBar();

    // MARK: pagination code
    const showNext = ({ item }) => {
        setPage(page + 1);

        const fetchNextData = async () => {
            var paginationQuery;

            paginationQuery = query(
                collection(dbFirestore, TableName.notes),
                orderBy("created_at", "desc"),
                limit(Constant.perPage),
                startAfter(item.created_at)
            );
            const querySnapshot = await getDocs(paginationQuery);

            setNotesData(
                querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
            );
            setPage(page + 1);
            setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
        };

        if (notesData.length === 0) {
            alert(ToastMessages.alertMessage);
        } else {
            fetchNextData();
        }
    };

    //  previous data function using pagination previous button
    const fetchPreviousData = async () => {
        setPage(page - 1);

        var paginationQuery;
        paginationQuery = query(
            collection(dbFirestore, TableName.notes),
            orderBy("created_at", "desc"),
            endBefore(notesData[0].created_at),
            limitToLast(Constant.perPage)
        );
        const querySnapshot = await getDocs(paginationQuery);

        setNotesData(
            querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
        );
        setPage(page - 1);
        setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    // condition while selecting the previous button
    const showPrevious = () => {
        if (notesData.length === 0) {
            fetchNotesApi();
        } else {
            fetchPreviousData();
        }
    };

    // MARK: Action
    // Edit data function
    const tapOnEdit = (data) => () => {
        navigate(RoutingPaths.editNotes, { state: data });
    };

    // Delete data function
    const tapOnDeleteConfirm = (data) => () => {
        Swal.fire({
            title: "Are you sure?",
            text: `You want to delete this note`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "var(--delete-button-color)",
            cancelButtonColor: "var(--cancel-button-list)",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.value) {
                deleteNotesApi(data);
            }
        });
    };

    // MARK: notes columns data
    const notesColumns = [
        {
            field: "note_data",
            header: "Description",
            className: "table__column__capital",
            CardBody: (data) => (
                <div className="notes-html-content"
                    dangerouslySetInnerHTML={{ __html: data.note_data }}
                />
            ),
        },
        {
            field: "created_at",
            header: "Created At",
            CardBody: (data) => (
                <Moment format={Dateformat.DDMMYYYHHMMSS}>{data.created_at}</Moment>
            ),
        },
        {
            field: "actions",
            header: "Actions",
            CardBody: (data) => (
                <>
                    <ListButtons
                        editclick={tapOnEdit(data)}
                        deleteclick={tapOnDeleteConfirm(data)}
                    />
                    <ToastContainer />
                </>
            ),
        },
    ];

    // MARK: modify student model in which we add new inputs in an array

    function stripHtml(html) {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    }

    function modifyStudentModel(doc) {
        const data = doc.data();

        return {
            note_data: data.note_data,
            created_at: moment(data.created_at).format(
                Dateformat.YYYYMMDD
            ),

        };
    }

    // MARK: export data in the excel sheet
    const exportToExcel = () => {
        Swal.fire({
            title: "Are you sure?",
            text: `You want to export these data.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "var(--delete-button-color)",
            cancelButtonColor: "var(--cancel-button-list)",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
        }).then(async (result) => {
            if (result.value) {
                const querySnapShot = await createQueryForExport();

                const mylist = querySnapShot.docs.map((model) =>
                    modifyStudentModel(model)
                );


                const filterData = mylist.map(
                    ({ note_data, created_at }) => ({
                        data: stripHtml(note_data),
                        created_at: created_at,
                    })
                );

                if (filteredDates) {
                    const workBook = XLSX.utils.book_new();
                    const workSheet = XLSX.utils.json_to_sheet(filterData);
                    XLSX.utils.book_append_sheet(workBook, workSheet, "notes");
                    XLSX.writeFile(workBook, "notes_data.xlsx");
                } else {
                    toast.error(ToastMessages.filterDate)
                }
            }
        });
    };

    if (isLoading) {
        return <div className="loading-div"> Loading ... </div>;
    }


    return (
        <div className="modules__main__div">
            <div className="col-12">
                <div className="card modules__card">
                    <div className="modules__lists_main-content">
                        <ListHeadingComponent
                            classname="flex-grow-1"
                            headingName={CommonHeadings.notesLayoutHeading}
                        />
                        <Button
                            label="Export Data"
                            type="button"
                            onClick={exportToExcel}
                            className="list__export_button me-2"
                        />
                        <AddButton navigation={RoutingPaths.addNotes} />
                    </div>
                    <DataTable
                        className="mt-5 mb-3"
                        value={notesData} header={header}
                        emptyMessage="No data found."
                    >
                        {notesColumns.map((col) => (
                            <Column
                                key={col.field}
                                field={col.field}
                                header={col.header}
                                bodyClassName={col.className}
                                body={col.CardBody}
                            />
                        ))}
                    </DataTable>

                    <ButtonGroup
                        style={{ gap: "1rem", alignSelf: "center" }}
                        className="mt-5"
                    >
                        {
                            <button
                                disabled={page === 0 ? true : false}
                                onClick={() => showPrevious()}
                                className={
                                    page === 0 ? "previous-disabled-button" : "previous-button"
                                }
                            >
                                <span className="pi pi-angle-left">Previous</span>
                            </button>
                        }

                        {
                            <button
                                disabled={isNext}
                                onClick={() =>
                                    showNext({
                                        item: notesData[notesData.length - 1],
                                    })
                                }
                                className={
                                    isNext ? "previous-disabled-button" : "previous-button"
                                }
                            >
                                Next<span className="pi pi-angle-right"></span>
                            </button>
                        }
                    </ButtonGroup>
                </div>
            </div>
        </div>
    )
}

export default NotesData;